import { render, staticRenderFns } from "./org.vue?vue&type=template&id=718b25bf&lang=pug&"
import script from "./org.vue?vue&type=script&lang=coffee&"
export * from "./org.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/opt/buildhome/repo/components/loading.vue').default,Notifications: require('/opt/buildhome/repo/components/notifications/notifications.vue').default})
